<template>
    <v-card class="card">
        <v-form ref="form" v-model="formConfig.valid">
            <v-text-field
                v-model="formConfig.firstInput.value"
                :rules="formConfig.firstInput.rules"
                :label="formConfig.firstInput.label"
                @input.native="formConfig.firstInput.inputMask"                  
            ></v-text-field>
            <v-text-field
                v-model="formConfig.secondInput.value"
                :rules="formConfig.secondInput.rules"
                :label="formConfig.secondInput.label"
                @input.native="formConfig.secondInput.inputMask"
            ></v-text-field>
        </v-form>
        <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn class="text-none teste" height="35px" dark color="#C4170C" @click="submit">{{formConfig.submitLabel}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name:'BaseFormCard',
    props:{
        cardConfig:{
            type:Object,
            required:true
        },
        formConfig: {
            type:Object,
            required:true
        }
    },
    methods: {
        submit(){
            this.$refs.form.validate()
            this.$emit('submit')
        }
    }
}
</script>

<style scoped>
    .card .v-form{
        height: 75%;
        padding:10px;
        display: flex;
        flex-direction: column;
    }

    .actions{
        height: 25%;
    }

    .flex{
        display: flex;
        flex-direction: column;
    }
</style>